import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BellOutlined } from '@ant-design/icons';

import { fetchMonitoringGroupUnprocessed } from '@/redux/alerts/monitoringGroupUnprocessedSlice';
import {
  connectSse,
  disconnectSse,
  SSE_CONSUMER_IDS,
  getMonitoringAlarmSseList,
  getMonitoringAlarmProcessedStreamKeysMap
} from '@/redux/sse/sseSlice';
import {
  groupsToVirtualSseItems,
  getStreamKey,
  getSeeData,
  isMonitoringAlertPayload
} from '@/views/commandCenter/profile/ServiceAlerts/monitoringSsePayloadUtils';

import './ServiceAlertsPanel.less';

/**
 * 与 MonitoringSseAlertsPanel 一致：HTTP group_unprocessed 虚拟项 + SSE 预警推送（安全包不算），
 * 按 monitoringAlarmProcessedStreamKeys 剔除已解除，统计 distinct streamKey 数量（路数）。
 */
function selectMonitoringUnprocessedRouteCount(state) {
  const {
    alerts: { monitoringGroupUnprocessed },
    sse: sseObj
  } = state;
  const { groups } = monitoringGroupUnprocessed;
  const javaVirtual = groupsToVirtualSseItems(groups);
  const sseAlerts = getMonitoringAlarmSseList(sseObj).filter((item) =>
    isMonitoringAlertPayload(getSeeData(item))
  );
  const processedKeys = getMonitoringAlarmProcessedStreamKeysMap(sseObj);
  const list = [...(javaVirtual || []), ...sseAlerts];
  const filtered =
    processedKeys && typeof processedKeys === 'object'
      ? list.filter((item) => !processedKeys[getStreamKey(item)])
      : list;
  const keySet = new Set();
  for (let i = 0; i < filtered.length; i += 1) {
    keySet.add(getStreamKey(filtered[i]));
  }
  return keySet.size;
}

const ServiceAlertsPanel = () => {
  const dispatch = useDispatch();
  const monitoringUnprocessedCount = useSelector(selectMonitoringUnprocessedRouteCount);

  useEffect(() => {
    dispatch(fetchMonitoringGroupUnprocessed({}));
    dispatch(connectSse({ consumerId: SSE_CONSUMER_IDS.COMMAND_CENTER_PANEL }));
    return () => {
      dispatch(disconnectSse({ consumerId: SSE_CONSUMER_IDS.COMMAND_CENTER_PANEL }));
    };
  }, [dispatch]);

  return (
    <div className="service-alerts-panel">
      <div className="alerts-content">
        <div className="alerts-left">
          <div className="alerts-title">监控预警</div>
          <div className="alerts-count">
            <span className="count-number">{monitoringUnprocessedCount}</span>
            <span className="count-unit">条</span>
          </div>
        </div>
        <div className="alerts-right">
          <BellOutlined className="alerts-icon" />
        </div>
      </div>
    </div>
  );
};

export default ServiceAlertsPanel;
